// extracted by mini-css-extract-plugin
export var borderTop = "index-module--borderTop--II0AB";
export var circle = "index-module--circle--+14Zz";
export var container = "index-module--container--rdFIC";
export var content = "index-module--content--Cij9C";
export var title = "index-module--title--K0Ac3";